import { useEffect } from 'react';
import JsBarcode from 'jsbarcode';

export const JSBarCodeGenerator = ({ text, format = 'CODE128' }) => {
  useEffect(() => {
    JsBarcode('#barcode', text, {
      format,
      margin: 0,
      displayValue: false,
      height: 120,
      width: 2.4,
    });
  }, [text]);

  return <svg className='parking-barcode' id='barcode' alt='barcode' preserveAspectRatio='none'></svg>;
};
